// extracted by mini-css-extract-plugin
export default {"list":"CardList_list__d8Dwr","button":"CardList_button__924YZ","buttonBox":"CardList_buttonBox__-gBNO","icon":"CardList_icon__xUiJp"};